import React from 'react'
import { Link } from '@mui/material'

const CellEmailLink = ({ data, value, styles, attribute }) => {
    const style = {
        ...styles,
    }

    const emailValue = data[attribute.name]

    if (!emailValue) {
        return '-'
    }

    return (
        <Link
            href={`mailto:${emailValue}`}
            style={style}
            underline="none"
            data-ai-explain={`Send email to ${emailValue}`}
        >
            {value}
        </Link>
    )
}

export default CellEmailLink
